"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _HBModal = _interopRequireDefault(require("./HBModal"));
var _mixins = require("../../styles/mixins");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Ai = _interopRequireDefault(require("@honeybook/icons/dist/icons/Ai16"));
var _excluded = ["children", "title"];
var HBAIModalWithIcon = function HBAIModalWithIcon(_ref) {
  var children = _ref.children,
    title = _ref.title,
    restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var titleWithICon = /*#__PURE__*/_react["default"].createElement(TitleWrapper, null, /*#__PURE__*/_react["default"].createElement(_Ai["default"], {
    useDefaultFill: true,
    svgProps: {
      style: {
        display: 'flex'
      }
    }
  }), title);
  return /*#__PURE__*/_react["default"].createElement(_HBModal["default"], (0, _extends2["default"])({
    theme: "ai"
  }, restProps, {
    title: titleWithICon
  }), children);
};
var _default = exports["default"] = HBAIModalWithIcon;
var TitleWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBAIModalWithIcon__TitleWrapper",
  componentId: "sc-6b35mk-0"
})(["", " gap:8px;"], _mixins.flexCenterVertical);
//# sourceMappingURL=HBAIModalWithIcon.js.map